import { authFetch } from "utils";

export const getAll = (dealID) =>
  authFetch(`${apiUrl}${version}/deals/${dealID}/stages/assets`, {
    method: "GET",
  });

export const create = ({ assetId, dealId, stage }) =>
  authFetch(`${apiUrl}${version}/deals/${dealId}/stages/${stage}/assets`, {
    method: "POST",
    json: { asset: { id: assetId } },
  });

export const destroy = (id) =>
  authFetch(`${apiUrl}${version}/deal_stage_assets/${id}`, {
    method: "DELETE",
  });
